import { graphql } from 'react-relay';
import PropTypes from 'prop-types';

import { isUnauthorizedError } from '@confluence/error-boundary/entry-points/isUnauthorizedError.ts';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';

import type { AdminKeyEligibilityQueryAdminKeyEligibilityQuery as AdminKeyEligibilityQueryAdminKeyEligibilityQuery$data } from './__types__/AdminKeyEligibilityQueryAdminKeyEligibilityQuery.ts';
export function AdminKeyEligibilityQuery({ children }: { children: any }): any {
	const { data, error, loading } =
		useQueryInterop<AdminKeyEligibilityQueryAdminKeyEligibilityQuery$data>(graphql`
			query AdminKeyEligibilityQueryAdminKeyEligibilityQuery {
				tenant {
					cloudId
				}
				confluenceTenantContext: confluence_tenantContext {
					editions {
						confluence
					}
				}
				user: confluence_atlassianUser(current: true) {
					id
					confluence {
						roles {
							canBeSuperAdmin
						}
					}
				}
			}
		`);
	let errorToReportToChildren: typeof error;
	let isUnauthorized = false;
	if (error) {
		if (isUnauthorizedError(error)) {
			// If `edition` is not permitted to the current user (e.g. anonymous
			// access is not permitted), then the current user is definitely not
			// eligible for admin key. So here an unauthorized error is an expected
			// error.
			markErrorAsHandled(error);
			isUnauthorized = true;
		} else {
			errorToReportToChildren = error;
		}
	}

	return children({
		canBeSuperAdmin: isUnauthorized
			? false
			: Boolean(data?.user?.confluence?.roles?.canBeSuperAdmin),
		edition: isUnauthorized ? undefined : data?.confluenceTenantContext?.editions?.confluence,
		error: errorToReportToChildren,
		loading,
	});
}
export declare namespace AdminKeyEligibilityQuery {
	export let propTypes: {
		children: PropTypes.Validator<(...args: any[]) => any>;
	};
}

AdminKeyEligibilityQuery.propTypes = {
	children: PropTypes.func.isRequired,
};
